import { Dialog, DialogActions, DialogContent, Stack, useTheme } from "@mui/material";
import { Button, Typography } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { useTemplateLifecycleActions } from "./useTemplateLifecycleActions";

type Props = {
    templateId: string;
    onClose: () => void;
};

export const ArchiveTemplateDialog = (props: Props) => {
    const { templateId, onClose } = props;
    const { t } = useTranslation();
    const theme = useTheme();
    const { execute, isLoading } = useTemplateLifecycleActions(templateId);
    const close = () => {
        if (!isLoading) onClose();
    };

    return (
        <Dialog
            open
            onClose={close}
            aria-labelledby={`archive-template-${templateId}`}
            fullWidth
            maxWidth="sm"
            onClick={(event) => event.stopPropagation()}
        >
            <Stack sx={{ px: theme.spacing(4), pt: theme.spacing(4) }}>
                <Typography id={`archive-template-${templateId}`} variant="h3">
                    {t("settings.action_plan_templates.archive.title", "Archive this template?")}
                </Typography>
            </Stack>
            <DialogContent sx={{ px: theme.spacing(4), pt: theme.spacing(2), pb: theme.spacing(4) }}>
                <Typography component="p" variant="body-regular">
                    {t(
                        "settings.action_plan_templates.archive.body",
                        "This template will no longer be offered to users. You can unarchive it at any time; it will then return to draft.",
                    )}
                </Typography>
            </DialogContent>
            <DialogActions
                sx={{
                    p: theme.spacing(4),
                    borderTop: 1,
                    borderColor: "divider",
                    flexDirection: "column",
                    gap: theme.spacing(2),
                    "& > :not(style) ~ :not(style)": { marginLeft: 0 },
                }}
            >
                <Button variant="primary" fullWidth disabled={isLoading} onClick={() => execute("archive", onClose)}>
                    {t("settings.action_plan_templates.archive.yes", "Yes, archive")}
                </Button>
                <Button variant="secondary" fullWidth disabled={isLoading} onClick={close}>
                    {t("settings.action_plan_templates.archive.cancel", "No, cancel")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
